import { useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"

import axios from "axios"
import { useAuth } from "contexts/auth-context"
import { useLayoutEffect } from "react"
import Form from "./form"
import nProgress from "nprogress"
import toast from "react-hot-toast"
import { useSWRConfig } from "swr"
import { usePage } from "contexts/page-context"
import moment from "moment"
import { useAuditLogContext } from "contexts/audit-log-context"

export default function Create({ title }) {
    const { user } = useAuth()
    const { cache } = useSWRConfig()

    const { queueAuditLog } = useAuditLogContext()

    const { setTransition } = usePage()

    const location = useLocation()
    const navigate = useNavigate()

    const [, setPrevRouteState] = useState({})
    const [errors, setErrors] = useState({})

    useLayoutEffect(() => {
        setPrevRouteState({
            back: location.state?.back,
            from: location.state?.from,
            transition: location.state?.transition
        })

        setTransition(location.state?.transition)
    }, [])

    const handleSubmit = (data) => {
        nProgress.start()

        toast.loading("Memuat", { id: "submit" })

        const url = `${process.env.REACT_APP_INVENTORY_API_URL}/satuan`
        const payload = {
            name: data.name,
            description: data.description || null,
            is_base: !!data.is_base,
            base_satuan_id: data.is_base ? null : data.base_satuan_id,
            qty_per_unit: data.is_base ? 1 : Number(data.qty_per_unit),
            created_by: user?.name,
        }

        axios.post(url, payload).then((response) => {
            queueAuditLog(url, response.config.method.toUpperCase(), "Create Satuan Data", user?.name, payload, null, moment().format('YYYY-MM-DD HH:mm:ss'), response.status)

            cache.clear()

            navigate({ pathname: '/satuan' })

            toast.success(response.data.message, { id: "submit" })
        }).catch((error) => {
            if (error.response?.status === 422) {
                setErrors(error.response.data.errors || {})
            }

            toast.error(error.response?.data?.message ?? "Terjadi kesalahan", {
                ariaProps: { superscript: error.response?.status },
                id: "submit"
            })
        }).finally(() => {
            nProgress.done()
        })
    }

    return (
        <Form errors={errors} onSubmit={handleSubmit} />
    )
}
